// import Vue from 'vue';
// import socketio from 'socket.io-client';
// import VueSocketIO from 'vue-socket.io';

const SocketServerBaseURLS = {
  // TODO: Add any manual overrides here
};

export const SocketServerBaseURL =
  SocketServerBaseURLS[process.env.NODE_ENV]
  || process.env.SOCKET_BASE_URL;

// keep a reference to the store
// let store;

// export const connectSocketInstanceToStore = (storeInstance) => {
//   store = storeInstance;
// };
export const connectSocketInstanceToStore = () => {};

// TODO: on logout/login as a different user, how to switch socket connections?
export const initializeSocket = () => {
  // const { authToken } = store.getters;
  // if (!authToken) return;

  // const query = `token=${authToken}`;
  // const socketInstance = socketio(SocketServerBaseURL, { query });
  // Vue.use(VueSocketIO, socketInstance, store);
};



// WEBPACK FOOTER //
// ./src/socketio-config.js